import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgChat = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 7.625C1 3.96611 3.96611 1 7.625 1H14.375C18.0339 1 21 3.96611 21 7.625V8.1875C21 11.4068 18.4907 14.04 15.3214 14.238L7.71329 20.7593C7.3828 21.0425 6.90704 21.0795 6.53677 20.8507C6.1665 20.6218 5.98679 20.1797 6.09236 19.7575L7.46967 14.2482C3.88253 14.1657 1 11.232 1 7.625ZM7.625 3C5.07068 3 3 5.07068 3 7.625C3 10.1793 5.07068 12.25 7.625 12.25H8.75C9.05794 12.25 9.3487 12.3919 9.53821 12.6346C9.72771 12.8773 9.79483 13.1938 9.72014 13.4925L8.79347 17.1992L14.2867 12.4907C14.468 12.3354 14.6988 12.25 14.9375 12.25C17.1812 12.25 19 10.4312 19 8.1875V7.625C19 5.07068 16.9293 3 14.375 3H7.625Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgChat);

export default ForwardRef;
